'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

WebApiMockService.$inject = ['$q', '$http'];


var _module = _angular2.default.module('cb.webApi-mock.service', []);

_module.factory('WebApiMockService', WebApiMockService);

exports.default = _module;


function WebApiMockService($q, $http) {
    var service = {
        get: get
    };

    return service;

    function _verifyRequest(request, control) {
        if (control === 'ZoekenWerkgeversControl') {
            return typeof request.ZoekenWerkgevers.zoekItem !== 'undefined' && typeof request.ZoekenWerkgevers.maxAantalResultaten !== 'undefined';
        } else if (control === 'OphalenWerkgeverControl') {
            return typeof request.WerkgeverId !== 'undefined';
        } else if (control === 'OphalenCollectiviteitKortingenControl') {
            return typeof request.OphalenCollectiviteitKortingen.WerkgeverId !== 'undefined';
        } else {
            return true;
        }
    }

    function get(request, control) {
        var defer = $q.defer();
        if (!_verifyRequest(request, control)) {
            defer.reject('RequestData not defined');
        }

        try {
            $http.get('/json/mock.json.js').then(function (result) {
                if (typeof result.data[control] === 'undefined') {
                    defer.reject('MockControl is not defined in JSON');
                }
                defer.resolve(result.data[control]);
            }, function () {
                defer.reject('Unexpected error');
            });
        } catch (e) {
            defer.reject(e.message);
        }
        return defer.promise;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/webapi/web-api-mock.service.js
// module id = 836
// module chunks = 0